module.exports = __webpack_public_path__ + "static/BP_GH2.7c5f8d48.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/BP_GH2.jpg
// module id = 883
// module chunks = 66982970260863